module.exports = __webpack_public_path__ + "img/wesoft.aa6a09ef.png";